import { Dispatch, SetStateAction, useState } from "react";
import * as s from "../InputPage.styles";
import { AnalysisForm } from "../machine";
import TractorSection from "./TractorSection";
import AccessorySection from "./AccessorySection";

interface Props {
  formData: AnalysisForm;
  setFormData: Dispatch<SetStateAction<AnalysisForm>>;
  handleNext: () => void;
}

function TractorInfo({ formData, setFormData, handleNext }: Props) {
  return (
    <s.Container>
      <s.Header>
        <s.StepWrapper>
          <s.Step>Step 1</s.Step>
          <s.StepDivider />
          <s.Step $active>Step 2</s.Step>
          <s.StepDivider />
          <s.Step>Step 3</s.Step>
        </s.StepWrapper>
        <s.Title>트랙터/부속기 정보 입력하기</s.Title>
        <s.Address>
          보유 중인 트랙터/부속기 정보를 입력해 작업 효율과 수익성 확인해보세요
        </s.Address>
      </s.Header>
      <s.Content>
        <TractorSection formData={formData} setFormData={setFormData} />
        <AccessorySection formData={formData} setFormData={setFormData} />

        <s.NextButton onClick={handleNext}>다음으로</s.NextButton>
      </s.Content>
    </s.Container>
  );
}

export default TractorInfo;
